import React, { memo } from 'react';
import { type MotionProps, motion } from 'framer-motion';
import { Image, type ImageProperties } from '@/components/ui/Image';

type OmittedImageProperties =
  | 'style'
  | 'children'
  | 'layout'
  | 'onDragEnd'
  | 'onDrag'
  | 'onDragStart'
  | 'onAnimationStart';

export interface MotionImageProperties
  extends MotionProps,
    Omit<ImageProperties, OmittedImageProperties> {}

const MotionComponent = motion.create(Image);

function MotionImage({ children, ...properties }: MotionImageProperties) {
  return <MotionComponent {...properties}>{children}</MotionComponent>;
}

export default memo(MotionImage);
